import type { Melody } from '@tunasong/schemas'
import type { FC } from 'react'
import { useEffect } from 'react'
import { useMelodyRollPlayback } from '../melody-roll/use-melody-roll-playback.js'

/** Plays one melody once, as soon as it mounts. Key it per take, so pressing Hear it again replays */
export const Audition: FC<{ melody: Melody }> = ({ melody }) => {
  const { play, stop } = useMelodyRollPlayback({ melody })
  useEffect(() => {
    play()
    return stop
  }, [play, stop])
  return null
}
